import store from '@/store';

function setVieportValue(isDesktop: boolean) {
  var viewport = document.querySelector('meta[name=viewport]');
  if(isDesktop) {
    viewport.setAttribute('content', 'width=1200');
  } else {
    viewport.setAttribute('content', 'width=device-width,initial-scale=1.0');
  }
}

export function switchDesktopMobileView(isDesktop: boolean) {
  setVieportValue(isDesktop)
  store.commit('mobileDesktopViewForcedCurrent', isDesktop);
}

export default (to: any, from: any, next: Function) => {
  if(to.meta && to.meta.ignoreDesktopViewForced) {
    setVieportValue(false);
  } else if(from && from.meta && from.meta.ignoreDesktopViewForced && to.meta && !to.meta.ignoreDesktopViewForced) {
    switchDesktopMobileView(store.state.mobile.desktopViewForced);
  } else if(
    store.state.mobile.desktopViewForced !== null
    && store.state.mobile.desktopViewForced !== store.state.mobile.desktopViewForcedCurrent
  ) {
    switchDesktopMobileView(store.state.mobile.desktopViewForced);
  }

  return next();
};
